import { uniq } from 'lodash';
import * as yup from 'yup';
import {
  addOptionalToSchema,
  domainSchema,
  idSchema,
  optionalNameSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';

const domain = domainSchema;

export const createOrganizationSchema = yup.object().shape({
  name: requiredNameSchema,
  domainGenerator: domain
    .test({
      name: 'different-domains',
      message: 'Domains must be different',
      test: (_, context) => {
        const domains = context.parent.domains;
        return uniq(domains).length === domains?.length;
      },
    })
    .test({
      name: 'min-domains-count',
      message: 'Must contain at least 1 domain',
      test: (_, context) => context.parent.domains.length > 0,
    })
    .optional(),
  domains: yup.array().of(domain.required()).required(requiredErrorMessage),

  google_places_id: yup.string().required(requiredErrorMessage),
  street: requiredNameSchema,
  suite: optionalNameSchema,
  city: requiredNameSchema,
  state: stateSchema.required(requiredErrorMessage),
  zip_code: zipSchema.required(requiredErrorMessage),
  county: optionalNameSchema,
  guide_participant_id: addOptionalToSchema(idSchema),
  tin: addOptionalToSchema(idSchema.min(9).max(17)),
});
